import { JsonObject, JsonProperty } from 'json2typescript';
import { Moment } from 'moment';

import { DateAdapter } from '../../client/helpers/serializer/adapters/date.adapter';
import { PBCBirthDateInterface } from '../../../core';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('PBCBirthdate')
export class PBCBirthdate implements PBCBirthDateInterface {
    @JsonProperty('fecha', DateAdapter)
    private _date: Moment = undefined;

    @JsonProperty('pais', StringAdapter)
    private _country: string = undefined;

    @JsonProperty('comentario', StringAdapter, true)
    private _comment?: string = undefined;

    get date(): Moment {
        return this._date;
    }

    get country(): string {
        return this._country;
    }

    get comment(): string {
        return this._comment;
    }
}
